/**
 * This method provides a way to get the value of a CSS variable.
 */
export const getCSSValue = (variable: string) => {
    return getComputedStyle(document.body).getPropertyValue(variable).trim();
};
